import { styled } from '@mui/material';
import { MuiColorInput } from 'mui-color-input';
import React from 'react';

export const ColorInput = ({ ...propsColorInput }) => {
  return (
    <MuiColorInputStyled
      {...propsColorInput?.value}
      {...propsColorInput?.onChange}
      {...propsColorInput}
      format="hex"
      variant="outlined"
      isAlphaHidden
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};
const MuiColorInputStyled = styled(MuiColorInput)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    justifyContent: 'center',
    borderRadius: '8px',
    padding: '20px 20px 24px 20px',
    '&.Mui-focused fieldset': {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
  '& .MuiInputAdornment-root': {
    marginRight: '0px',
  },
  '& .MuiFormControl-root.MuiTextField-root': {
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
  },
  '& fieldset': {
    '& legend': {
      display: 'none',
    },
  },
  '& .MuiInputBase-input': {
    padding: '10px 16px',
    color: theme.palette.text.primary,
    display: 'none',
  },
}));
